import PlatformCapabilities from '@/Capabilities';
import AnalyticsTracking from '@/Plugins/AnalyticsTracking';

export async function registerServiceWorker() {
    try {
        if ('serviceWorker' in navigator && PlatformCapabilities.pushCapability) {
            await navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' } );
        }
    }
    catch (error) {
        const analyticsTracking = new AnalyticsTracking();
        analyticsTracking.sendCustomEvent({
            category: 'error',
            action: 'service-worker-registration',
            label: `Service Worker registration failed: ${error}`,
        });
    }
}